module.exports = __webpack_public_path__ + "img/toplupe-detail.20043c3.png";